package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.LoginW500Rounded: ImageVector
    get() {
        if (_loginW500Rounded != null) {
            return _loginW500Rounded!!
        }
        _loginW500Rounded = Builder(name = "LoginW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(523.59f, 848.13f)
                quadToRelative(-19.16f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(233.54f)
                verticalLineToRelative(-554.26f)
                lineTo(523.59f, 202.87f)
                quadToRelative(-19.16f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(233.54f)
                quadToRelative(37.78f, 0.0f, 64.39f, 26.61f)
                reflectiveQuadToRelative(26.61f, 64.39f)
                verticalLineToRelative(554.26f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(523.59f, 848.13f)
                close()
                moveTo(428.35f, 525.5f)
                lineTo(157.37f, 525.5f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(270.98f)
                lineToRelative(-69.5f, -69.5f)
                quadToRelative(-12.68f, -12.67f, -12.68f, -31.07f)
                quadToRelative(0.0f, -18.39f, 12.68f, -31.82f)
                quadToRelative(12.67f, -13.68f, 31.7f, -14.06f)
                quadToRelative(19.04f, -0.38f, 32.71f, 13.3f)
                lineToRelative(146.83f, 146.82f)
                quadToRelative(13.43f, 13.68f, 13.43f, 31.83f)
                reflectiveQuadToRelative(-13.43f, 31.83f)
                lineTo(423.26f, 658.65f)
                quadToRelative(-13.43f, 13.68f, -32.21f, 13.3f)
                quadToRelative(-18.77f, -0.38f, -32.2f, -14.06f)
                quadToRelative(-12.68f, -13.43f, -12.3f, -32.21f)
                quadToRelative(0.38f, -18.77f, 13.06f, -31.44f)
                lineToRelative(68.74f, -68.74f)
                close()
            }
        }
        .build()
        return _loginW500Rounded!!
    }

private var _loginW500Rounded: ImageVector? = null
